import {
  WEEKDAYS_LABELS,
  WeekdaysKeys,
} from 'shared/components/date-picker/weekdaysPicker/constants'

export enum WeekdaysBackendEnum {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
}

export const weekdaysLocoKeys = {
  [WeekdaysBackendEnum.Sunday]: WEEKDAYS_LABELS[WeekdaysKeys.Sunday],
  [WeekdaysBackendEnum.Monday]: WEEKDAYS_LABELS[WeekdaysKeys.Monday],
  [WeekdaysBackendEnum.Tuesday]: WEEKDAYS_LABELS[WeekdaysKeys.Tuesday],
  [WeekdaysBackendEnum.Wednesday]: WEEKDAYS_LABELS[WeekdaysKeys.Wednesday],
  [WeekdaysBackendEnum.Thursday]: WEEKDAYS_LABELS[WeekdaysKeys.Thursday],
  [WeekdaysBackendEnum.Friday]: WEEKDAYS_LABELS[WeekdaysKeys.Friday],
  [WeekdaysBackendEnum.Saturday]: WEEKDAYS_LABELS[WeekdaysKeys.Saturday],
}

export interface AvailabilitySlot {
  id: number | string
  startTime: number | null
  endTime: number | null
  date: string | null
  dayOfWeek: string | null
}

export interface UnavailabilitySlot {
  startDate: string
  endDate: string
}

export type AvailabilitySlotId = AvailabilitySlot['id']

export interface AvailabilityCreateInterface {
  unavailabilityRanges: UnavailabilitySlot[]
  dailySettings: Omit<AvailabilitySlot, 'id'>[]
  timezone: string
}

export interface AvailabilityGetInterface {
  id: number
  eventId: number
  days: string | null
  ownerId: number
  dailySettings: AvailabilitySlot[]
  timezone: string
  unavailabilityRanges: UnavailabilitySlot[]
}

export interface AvailabilityUpdateInterface extends AvailabilityCreateInterface {}

export type AvailabilitySlotFieldError = 'startTime' | 'endTime' | 'date'
export type ErrorPathKey<P extends string> = `${P}[${number}].${AvailabilitySlotFieldError}`

type DateSpecificErrorKey = ErrorPathKey<'dateSpecificDailySettings'>
type WeeklyErrorKey = ErrorPathKey<'weeklyDailySettings'>
type UnavailabilityErrorKey = `unavailabilityRanges[${number}].${keyof UnavailabilitySlot}`

export type AvailabilityErrors = {
  date?: string
  validTimeRange?: string
  dateOrDayOfWeek?: string
} & Partial<Record<DateSpecificErrorKey | WeeklyErrorKey | UnavailabilityErrorKey, string>>
